import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import Card from '../components/card';
import { BorrowerCard } from './card-lenses';

const CreditScore = ({ model, onChange, ...cardProps }) => (
  <Card title="What is your approximate credit score?" {...cardProps}>
    <SelectField
      hintText="Select one"
      value={model.get('approximateCreditScore')}
      onChange={(event, key, value) => onChange('approximateCreditScore', value)}
    >
      <MenuItem value={600} primaryText="Below 620" />
      <MenuItem value={620} primaryText="620-679" />
      <MenuItem value={680} primaryText="680-719" />
      <MenuItem value={720} primaryText="Above 720" />
    </SelectField>
  </Card>
);

CreditScore.completed = ({ model }) => model.get('approximateCreditScore') != null;

CreditScore.id = 'ApproximateCredit';

export default BorrowerCard(CreditScore);



// WEBPACK FOOTER //
// ./src/cards/credit-score.js